const $ = require("jquery")
require("slick-carousel")

$(function(){
  
  $('.hero-carousel').each( function(){
    $(this).slick({
      infinite: true,
      dots: true,
      autoplay: true,
      arrows: false,
      fade: true,
      adaptiveHeight: true,
      autoplaySpeed: 5500,
      speed: 450,
      pauseOnHover: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      //appendArrows: $(this).parent().find('.arrows-container')

    })
  });
  $('.slick-carousel').slick({infinite: true,
                              slidesToShow: 4, 
                              slidesToScroll: 1,
                              dots: true,
                              responsive: [
                                {
                                  breakpoint: 768,
                                  settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    infinite: true,
                                  }
                                }
                              ]
                            
                            });
})
